exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Favorite__favoriteButton___17gE4 {\n  font-weight: 500;\n  font-size: 16px;\n  cursor: pointer;\n  height: 64px;\n  width: calc(50% - 10px);\n  border-radius: 8px;\n  padding: 19px 0;\n  text-align: center; }\n\n.Favorite__text___L7PHA {\n  vertical-align: middle; }\n  @media (max-width: 576px) {\n    .Favorite__text___L7PHA {\n      font-size: 14px; } }\n", ""]);

// exports
exports.locals = {
	"favoriteButton": "Favorite__favoriteButton___17gE4",
	"text": "Favorite__text___L7PHA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/Favorite/Favorite.scss
// module id = 4479
// module chunks = 6